export type VisualQuality = 'Basic' | 'Advanced' | 'Premium' | 0 | 1 | 2;

// Package DTO
export interface Package {
  id: string;
  name: string;
  description: string | null;
  monthlyPrice: number;
  currency: string;
  maxUsers: number;
  maxWordPressSites: number;
  monthlyContentLimit: number;
  overageContentPrice: number;
  isActive: boolean;
  sortOrder: number;
  bulkContentEnabled: boolean;
  maxBulkContentPerRequest: number;
  linkAssistantEnabled: boolean;
  productionPriority: number;
  visualQuality: VisualQuality;
  createdAt: string;
  updatedAt: string | null;
}

// Create Package Request
export interface CreatePackageRequest {
  name: string;
  description?: string | null;
  monthlyPrice: number;
  currency: string;
  maxUsers: number;
  maxWordPressSites: number;
  monthlyContentLimit: number;
  overageContentPrice: number;
  sortOrder?: number;
  bulkContentEnabled?: boolean;
  maxBulkContentPerRequest?: number;
  linkAssistantEnabled?: boolean;
  productionPriority?: number;
  visualQuality?: VisualQuality;
}

// Update Package Request
export interface UpdatePackageRequest {
  name?: string;
  description?: string | null;
  monthlyPrice?: number;
  currency?: string;
  maxUsers?: number;
  maxWordPressSites?: number;
  monthlyContentLimit?: number;
  overageContentPrice?: number;
  isActive?: boolean;
  sortOrder?: number;
  bulkContentEnabled?: boolean;
  maxBulkContentPerRequest?: number;
  linkAssistantEnabled?: boolean;
  productionPriority?: number;
  visualQuality?: VisualQuality;
}

// API Response wrapper
export interface ApiResponse<T> {
  success: boolean;
  message: string | null;
  data: T;
}

// Currency options
export const currencyOptions = [
  { value: 'USD', label: 'USD ($)' },
  { value: 'EUR', label: 'EUR (€)' },
  { value: 'TRY', label: 'TRY (₺)' },
];

// Format price helper
export const formatPrice = (price: number, currency: string): string => {
  const symbols: Record<string, string> = {
    USD: '$',
    EUR: '€',
    TRY: '₺',
  };
  return `${symbols[currency] || currency}${price.toFixed(2)}`;
};
